import { render, staticRenderFns } from "./TaskCardDetail.vue?vue&type=template&id=219b23ae"
import script from "./TaskCardDetail.vue?vue&type=script&lang=js"
export * from "./TaskCardDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports